import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";
import Preloader from "../../views/Preloader/Preloader";

import RendimientoAcademico from './RendimientoAcademico';

import CheckData from '../../shared/CheckData';

let statusUser = 0;
class MainConsultasEst extends Component {
    state = {
        valorRegistro: { value: 'rendimiento_academico', label: 'Rendimiento Académico' },
        statusUser: 0,
    }

    constructor (props) {
        super (props);
        CheckData((resp) => {
            statusUser = parseInt(resp)
            this.setState ({
                statusUser: parseInt(resp)
            })
        });
    }

    Selecciona = (link) => {
        switch (link) {
            case "/est_consultas/rendimiento_academico":
                return({ value: 'rendimiento_academico', label: 'Rendimiento Académico' })
            default:
                return({ value: 'rendimiento_academico', label: 'Rendimiento Académico' })
        }
    }

    valorRegistroLabel = (link) => {
        switch (link) {
            case "/est_consultas/rendimiento_academico": return('Rendimiento Académico')
            default: return('Rendimiento Académico')
        }
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/est_consultas/rendimiento_academico" component={ () => <RendimientoAcademico/> } />
                <Redirect to = "/est_consultas/rendimiento_academico" />
            </Switch>
        )
    }

    valorSelectRegistro = (valorRegistro) => {
        this.setState({
            valorRegistro
        },() => {
            this.props.history.push(`/est_consultas/${this.state.valorRegistro.value}`);
        });
    }

    contenidOk = () => {
        const Registros = [
            { value: 'rendimiento_academico', label: 'Rendimiento Académico' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:10}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona el tipo de Proceso
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorSelectRegistro}
                                    options={Registros}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`Opciones de ${this.valorRegistroLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }

    render() { 
        switch (statusUser) {
            case 0:
                return(<Preloader/>) 
            case 1:
                return (<Redirect to="/perfil" />)
            case 2:
                return (<Redirect to="/perfil" />)
            case 3:
                return (this.contenidOk())
            case 4:
                return (<Redirect to="/perfil" />)
            case 5:
                return (<Redirect to="/admision" />)
            default:
                return(<Preloader/>) 
        }
    }
}
 
export default MainConsultasEst;


// WEBPACK FOOTER //
// ./src/views/EstConsultas/MainConsultasEst.jsx